import { render, staticRenderFns } from "./BagHero.vue?vue&type=template&id=0c9a321c&"
import script from "./BagHero.vue?vue&type=script&lang=js&"
export * from "./BagHero.vue?vue&type=script&lang=js&"
import style0 from "./BagHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports